// Function to handle sidebar toggle for mobile screens
export function handleMobileSidebarToggle(body, overlay) {
  // const windowWidth = window.innerWidth;
  // const body = document.getElementById("body");
  // let overlay = document.querySelector(".mobile-sticky-body-overlay");

  // if (windowWidth < 768) {
    // const sidebarToggle = document.querySelector(".sidebar-toggle");

    // sidebarToggle.addEventListener("click", function (e) {
    
      const computedStyle = window.getComputedStyle(overlay);
      document.body.style.overflow = "hidden";


      if (computedStyle.display == 'none') {


        body.classList.add("sidebar-mobile-in");
        body.classList.remove("sidebar-mobile-out");
        document.body.style.overflow = "auto";
        // overlay.style.display = 'none'
      }
      overlay.style.display = 'block'

      // handleSidebarLayout()
    // });
  }
// }

// Function to handle sidebar menu clicks
export function handleSidebarMenuClicks() {
  const hasSubLinks = document.querySelectorAll(".sidebar .nav > .has-sub > a");
  const hasSubSubLinks = document.querySelectorAll(".sidebar .nav > .has-sub .has-sub > a");

  hasSubLinks.forEach(function (link) {
    link.addEventListener("click", function () {
      const parent = link.parentElement;
      parent.parentElement.querySelectorAll(".expand").forEach(function (item) {
        item.classList.remove("expand");
      });
      parent.classList.toggle("expand");
    });
  });

  hasSubSubLinks.forEach(function (link) {
    link.addEventListener("click", function () {
      link.parentElement.classList.toggle("expand");
    });
  });
}

// Function to handle sidebar toggle for various sidebar layouts
export const handleSidebarLayout = (body) => {
  // const windowWidth = window.innerWidth;
  // const body = document.getElementById("body");

  // if (windowWidth >= 768) {
    // if (body.classList.contains("sidebar-mobile-in") || body.classList.contains("sidebar-mobile-out")) {
    //   body.classList.remove("sidebar-mobile-in", "sidebar-mobile-out");
    // }

    const sidebarToggler = document.getElementById("sidebar-toggler");

    // sidebarToggler.addEventListener("click", function () {
      if (body.classList.contains("sidebar-fixed-offcanvas") || body.classList.contains("sidebar-static-offcanvas")) {
        sidebarToggler.classList.add("sidebar-offcanvas-toggle");
        sidebarToggler.classList.remove("sidebar-toggle");

        if (!window.isCollapsed) {
          body.classList.add("sidebar-collapse");
          window.isCollapsed = true;
          window.isMinified = false;
        } else {
          body.classList.remove("sidebar-collapse");
          body.classList.add("sidebar-collapse-out");
          setTimeout(function () {
            body.classList.remove("sidebar-collapse-out");
          }, 300);
          window.isCollapsed = false;
        }
      }

      if (body.classList.contains("sidebar-fixed") || body.classList.contains("sidebar-static")) {
        sidebarToggler.classList.add("sidebar-toggle");
        sidebarToggler.classList.remove("sidebar-offcanvas-toggle");

        if (!window.isMinified) {
          body.classList.remove("sidebar-collapse", "sidebar-minified-out");
          body.classList.add("sidebar-minified");
          window.isMinified = true;
          window.isCollapsed = false;
        } else {
          body.classList.remove("sidebar-minified");
          body.classList.add("sidebar-minified-out");
          window.isMinified = false;
        }
      }
    // });
  // }

  // if (windowWidth >= 768 && windowWidth < 992) {
  //   if (body.classList.contains("sidebar-fixed") || body.classList.contains("sidebar-static")) {
  //     body.classList.remove("sidebar-collapse", "sidebar-minified-out");
  //     body.classList.add("sidebar-minified");
  //     window.isMinified = true;
  //   }
  // }
}


// export const handleOnPageLoad = () => {
//   const windowWidth = window.innerWidth;
//   const body = document.getElementById("body");
//   window.isMinified = false;
//   window.isCollapsed = false;

//     if (windowWidth >= 768) {
//       if (body.classList.contains("sidebar-mobile-in") || body.classList.contains("sidebar-mobile-out")) {
//         body.classList.remove("sidebar-mobile-in", "sidebar-mobile-out");
//       }

//       window.isMinified = false;
//       window.isCollapsed = false;
//   }

//   if (windowWidth >= 768 && windowWidth < 992) {
//     if (body.classList.contains("sidebar-fixed") || body.classList.contains("sidebar-static")) {
//       body.classList.remove("sidebar-collapse", "sidebar-minified-out");
//       body.classList.add("sidebar-minified");
//       window.isMinified = true;
//     }
//   }
// }

export const handleOnPageLoad = () => {
  const windowWidth = window.innerWidth;
  const body = document.getElementById("body");
  window.isMinified = false;
  window.isCollapsed = false;

    if (windowWidth >= 992) {
      if (body.classList.contains("sidebar-mobile-in") || body.classList.contains("sidebar-mobile-out")) {
        body.classList.remove("sidebar-mobile-in", "sidebar-mobile-out");
      }

      window.isMinified = false;
      window.isCollapsed = false;
  }

  if (windowWidth >= 768 && windowWidth < 992) {
    if (body.classList.contains("sidebar-fixed") || body.classList.contains("sidebar-static")) {
      body.classList.remove("sidebar-collapse", "sidebar-minified-out");
      body.classList.add("sidebar-minified");
      window.isMinified = true;
    }
  }

  if (windowWidth < 768) {
    if (body.classList.contains("sidebar-fixed") || body.classList.contains("sidebar-static")) {
      body.classList.remove("sidebar-collapse", "sidebar-minified-out", "sidebar-minified-in", "sidebar-mobile-in");
      body.classList.add("sidebar-minified", "sidebar-mobile-out");
      // window.isMinified = false;
      // window.isCollapsed = false;
    }
  }
}

export const handleSidebarClick = () => {
  const windowWidth = window.innerWidth;
  const body = document.getElementById("body");
  let overlay = document.querySelector(".mobile-sticky-body-overlay");

  if (windowWidth < 768) {
    handleMobileSidebarToggle(body, overlay)
  } else if(windowWidth >= 768){
    handleSidebarLayout(body)
  }
}

export const handleOverlayClick = () =>{
    const body = document.getElementById("body");
    let overlay = document.querySelector(".mobile-sticky-body-overlay");
      // overlay.addEventListener("click", function (e) {
      const computedStyle = window.getComputedStyle(overlay);
      if (computedStyle.display == 'block') {
        body.classList.remove("sidebar-mobile-in");
        body.classList.add("sidebar-mobile-out", "sidebar-minified");
        document.body.style.overflow = "auto";
        // overlay.style.display = 'none'
      }
      overlay.style.display = 'none'
    // });
}



